import CustomerCenterFilter from "../features/customers-center/components/customer-center-filter";

export default function CustomersCheckView() {
  return (
    <>
      <CustomerCenterFilter/>
    </>
  )
}